import { makeStyles } from '@material-ui/core';

export default makeStyles({
  formItem: {
    marginTop: 24,
  },
});
